<template>
  <header class="app-header" :class="{ scrolled: isScrolled }">
    <nav class="header-nav container">
      <router-link to="/" class="logo" @click="closeMobileNav">
        <img src="@/assets/logo-white.png" alt="Fixtronic Logo" class="header-logo" />
      </router-link>
      <ul class="nav-links" :class="{ 'mobile-active': isMobileNavOpen }">
        <li><router-link to="/" @click="closeMobileNav">Start</router-link></li>
        <li><a href="https://facetronic.de/kontakt" target="_blank" rel="noopener noreferrer" @click="closeMobileNav">Kontakt</a></li>
        <li><a href="https://fixtronic.io/" target="_blank" rel="noopener noreferrer" @click="closeMobileNav">Login</a></li>
        <li class="nav-cta-item">
          <a href="https://link.facetronic.de/fixtronic" class="cta-button nav-cta" target="_blank">Live-Demo</a>
        </li>
      </ul>
      <button
        class="mobile-nav-toggle"
        @click="toggleMobileNav"
        :class="{ 'is-active': isMobileNavOpen }"
        aria-label="Navigation umschalten"
      >
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      isMobileNavOpen: false,
      isScrolled: false
    };
  },
  methods: {
    toggleMobileNav() {
      this.isMobileNavOpen = !this.isMobileNavOpen;
      document.body.style.overflow = this.isMobileNavOpen ? 'hidden' : '';
    },
    closeMobileNav() {
      this.isMobileNavOpen = false;
      document.body.style.overflow = '';
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 20;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', () => {
      if (window.innerWidth > 900 && this.isMobileNavOpen) {
        this.closeMobileNav();
      }
    });
    document.addEventListener('click', (event) => {
      const header = this.$el;
      if (this.isMobileNavOpen && !header.contains(event.target)) {
        this.closeMobileNav();
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    document.body.style.overflow = '';
  }
}
</script>

<style scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  transition: box-shadow 0.3s ease, background 0.3s ease;
}

.app-header.scrolled {
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
}

.header-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;
}

.logo {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.logo img {
  height: 36px;
  width: auto;
}

.header-logo {
  filter: brightness(0) saturate(100%);
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 32px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-links a {
  color: var(--color-secondary);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95em;
  transition: color 0.2s ease;
}

.nav-links a:hover,
.nav-links a.router-link-active {
  color: var(--color-primary);
}

.nav-cta {
  padding: 10px 24px !important;
  border-radius: var(--border-radius-md);
  font-size: 0.9em !important;
}

.mobile-nav-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  z-index: 1001;
}

.icon-bar {
  display: block;
  width: 24px;
  height: 2px;
  margin: 5px 0;
  background-color: var(--color-secondary);
  transition: all 0.3s ease;
  border-radius: 2px;
}

@media (max-width: 900px) {
  .mobile-nav-toggle {
    display: block;
  }

  .mobile-nav-toggle.is-active .icon-bar:nth-child(1) {
    transform: translateY(7px) rotate(45deg);
  }

  .mobile-nav-toggle.is-active .icon-bar:nth-child(2) {
    opacity: 0;
  }

  .mobile-nav-toggle.is-active .icon-bar:nth-child(3) {
    transform: translateY(-7px) rotate(-45deg);
  }

  .nav-links {
    position: fixed;
    top: 0;
    right: -100%;
    width: 100%;
    height: 100vh;
    background: var(--color-background);
    flex-direction: column;
    justify-content: center;
    gap: 36px;
    transition: right 0.3s ease;
    padding: 80px 24px 24px;
    box-sizing: border-box;
  }

  .nav-links.mobile-active {
    right: 0;
  }

  .nav-links a {
    font-size: 1.2em;
    display: block;
    text-align: center;
  }

  .nav-cta-item {
    margin-top: 16px;
  }
}
</style>
